jQuery(document).ready(function ($) {
  $('.faq-sec accordion-custom details').on('click', function (e) {
    const $current = $(this);
    if ($current.attr('open') !== undefined) {
      return;
    }
    $('.faq-sec accordion-custom').each(function(){
        $(this).find('details').not($current).removeAttr('open');
    });
    // $('.faq-sec accordion-custom details[open]').not($current).removeAttr('open');
  });


  $('.product-details accordion-custom details').on('click', function (e) {
    const $current = $(this);
    if ($current.attr('open') !== undefined) {
      return;
    }
    $('.product-details accordion-custom').each(function(){
        $(this).find('details').not($current).removeAttr('open');
    });
    // $('.product accordion-custom details[open]').not($current).removeAttr('open');
  });

  document.addEventListener("scroll", function () {
    const heroSection = document.querySelector(".hero.hero_banner.index_banner");
    const button = heroSection ? heroSection.querySelector(".button") : null;
    if (!heroSection || !button) return;

    const rect = heroSection.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const bottomThreshold = viewportHeight * 0.7; // 30% from bottom

    // When hero top reaches top but bottom not yet hit threshold → animate down
    if (rect.top <= 0 && rect.bottom > bottomThreshold) {
      button.classList.add("scroll_animate");
      button.classList.remove("scroll_fixed");
    }
    // When hero bottom reaches threshold → fix at bottom
    else if (rect.bottom <= bottomThreshold) {
      button.classList.add("scroll_fixed");
      button.classList.remove("scroll_animate");
    }
    // When scrolling back up → reset
    else {
      button.classList.remove("scroll_animate", "scroll_fixed");
    }
  });


});


// 25 nov  video 

document.addEventListener("DOMContentLoaded", function () {
  const wrappers = document.querySelectorAll(".custom-video-wrapper");

  function pauseAllExcept(current) {
    wrappers.forEach(w => {
      const v = w.querySelector(".real-video");
      const thumb = w.querySelector(".video-thumbnail");
      const hidden = w.querySelector(".hidden-video");
      const playBtn = w.querySelector(".play-btn");
      const pauseBtn = w.querySelector(".pause-btn");
      const volOff = w.querySelector(".volume-off-btn");
      const volOn = w.querySelector(".volume-on-btn");

      if (v !== current) {
        v.pause();
        v.muted = true;

        playBtn.classList.remove("hidden");
        pauseBtn.classList.add("hidden");
        volOn.classList.add("hidden");
        volOff.classList.remove("hidden");

        thumb.style.display = "block";
        hidden.style.display = "none";
      }
    });
  }

  wrappers.forEach(wrapper => {
    const video = wrapper.querySelector(".real-video");
    const playBtn = wrapper.querySelector(".play-btn");
    const pauseBtn = wrapper.querySelector(".pause-btn");
    const thumbnail = wrapper.querySelector(".video-thumbnail");
    const hiddenContainer = wrapper.querySelector(".hidden-video");

    const volumeOffBtn = wrapper.querySelector(".volume-off-btn");
    const volumeOnBtn = wrapper.querySelector(".volume-on-btn");

    // PLAY
    playBtn.addEventListener("click", () => {
      pauseAllExcept(video);

      thumbnail.style.display = "none";
      hiddenContainer.style.display = "block";

      playBtn.classList.add("hidden");
      pauseBtn.classList.remove("hidden");

      // Respect the current volume state
      video.muted = volumeOffBtn.classList.contains("hidden") ? false : true;

      video.play();
    });

    // PAUSE BUTTON
    pauseBtn.addEventListener("click", () => {
      video.pause();
      pauseBtn.classList.add("hidden");
      playBtn.classList.remove("hidden");
    });

    // CLICK VIDEO = PAUSE
    video.addEventListener("click", () => {
      video.pause();
      pauseBtn.classList.add("hidden");
      playBtn.classList.remove("hidden");
    });

    // LOOP VIDEO
    video.addEventListener("ended", () => {
      video.play();
    });

    // Hover pause button
    wrapper.addEventListener("mouseenter", () => {
      if (!video.paused) pauseBtn.classList.remove("hidden");
    });

    wrapper.addEventListener("mouseleave", () => {
      pauseBtn.classList.add("hidden");
    });

    // Volume mute/unmute
    volumeOffBtn.addEventListener("click", () => {
      video.muted = false;
      volumeOffBtn.classList.add("hidden");
      volumeOnBtn.classList.remove("hidden");
    });

    volumeOnBtn.addEventListener("click", () => {
      video.muted = true;
      volumeOnBtn.classList.add("hidden");
      volumeOffBtn.classList.remove("hidden");
    });
  });
});
